"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = void 0;
var crc16_1 = __importDefault(require("crc/crc16"));
function create(name) {
    var crc = crc16_1.default(name);
    var add = function (v) {
        crc = crc16_1.default('|' + v, crc);
    };
    var addVec2 = function (v) {
        add(v.x);
        add(v.y);
    };
    var addRound = function (v, doRound) {
        if (doRound === void 0) { doRound = true; }
        if (doRound) {
            add(Math.round(v * 1000));
        }
        else {
            add(v);
        }
    };
    var addVec2Round = function (v, doRound) {
        if (doRound === void 0) { doRound = true; }
        addRound(v.x, doRound);
        addRound(v.y, doRound);
    };
    return {
        add: add,
        addVec2: addVec2,
        addRound: addRound,
        addVec2Round: addVec2Round,
        getCrc: function () { return crc; },
    };
}
exports.create = create;
